// extracted by mini-css-extract-plugin
module.exports = {"player":"Player_player__MXOqk","content":"Player_content__2Ke_0","close":"Player_close__wyNwH"};